/* eslint-disable quotes */

// components.application.dashboard.widgets.cloudSummary

export const CLOUD_SUMMARY = {
  title: 'Cloud Infrastructure Summary',
  description:
    'The cloud environments that host your systems (e.g. AWS, Azure, Google Cloud) should have security enabled in these key areas. Ideally, there should be more "Implemented" responses than "Needs Attention".'
};
